/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2020-12-29 13:39:49
 * @LastEditTime: 2021-01-30 16:03:18
 * @FilePath: /yft-b2c-web-h5/src/pages/Learn/My/MyCollect/MyCollectMod.js
 */
// 状态管理方法
import { observable, action, flow } from 'mobx';
// 引入Serv
import Serv from './indexServ';

class MyCollectMod {
  // 每页数量
  @observable pageSize = 10;
  // 页码
  @observable pageNum = 1;
  // 是否结束
  @observable end = false;
  // 加载中
  @observable loading = false;

  //菜单列表
  @observable list = [];
  //每行的数量
  @observable rowNum = 1;

  //添加的空对象
  @observable emptyNum = 0;
  @observable infinite = false;
  @observable useGrid = false; // 使用gird布局 仅在rowNum > 1时生效

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  setData(data) {
    this.loading = false;
    if (data.list && data.list.length) {
      if (this.emptyNum > 0) {
        // console.log(this.list.length - this.emptyNum);
        this.list = this.list.slice(0, this.list.length - this.emptyNum);
      }
      this.list = this.list.concat(data.list);
      if (this.rowNum > 1 && !this.useGrid) {
        if (parseInt(this.list.length % this.rowNum) > 0) {
          this.emptyNum = this.rowNum - parseInt(this.list.length % this.rowNum);
          for (let i = 0; i < this.emptyNum; i++) {
            this.list.push({
              isHidden: true
            });
          }
        }
      }
      // this.list = this.list.concat(data.list);
      this.pageNum = this.pageNum + 1;
    }
    this.end = this.pageSize * (this.pageNum - 1) >= data.total;
  }

  /**
   * 获取列表
   */
  getList = flow(function* (apiInfo, othP) {
    let params = { pageNum: this.pageNum, pageSize: this.pageSize, ...othP };
    try {
      const { data } = yield Serv.getList(params, apiInfo);
      if (data.list == null || data.list.length == 0) {
        this.infinite = true;
      }
      data.list =
        Array.isArray(data.list) &&
        data.list.map((item, index) => {
          item.index = index;
          return item;
        });
      this.setData(data);
    } catch (error) {
      console.log(error);
    }
  });
}

export default MyCollectMod;



// WEBPACK FOOTER //
// ./src/pubBiz/InfiniteScrollByAntd/indexMod.js